"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pixelsToMms = exports.mmsToPixels = void 0;
var ONE_INCH_IN_MMS = 25.4;
var mmsToPixels = exports.mmsToPixels = function mmsToPixels(mms) {
  var dpi = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  return Math.ceil(mms / ONE_INCH_IN_MMS * dpi);
};
var pixelsToMms = exports.pixelsToMms = function pixelsToMms(pixels) {
  var dpi = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  return Math.floor(pixels / dpi * ONE_INCH_IN_MMS);
};